import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getNuggetsAction } from '../../../utils/redux/nuggets/nuggetAction';
// import './NuggetPage.css'
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../CSS/common.css';

const NuggetPage = () => {

    const { nuggets } = useSelector(state => state.nuggets);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [searchQuery, setSearchQuery] = useState(params.get('searchQuery') || '');

    const fetchNuggets = async () => {
        const param = {
            search: searchQuery,
        };
        await dispatch(getNuggetsAction(param));
    }

    useEffect(() => {
        fetchNuggets();
    }, []);

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            navigate(`/nuggets?searchQuery=${searchQuery}`);
            const param = {
                search: searchQuery,
            };
            dispatch(getNuggetsAction(param));
        }
    };

    const handleSearchButtonClick = () => {
        navigate(`/nuggets?searchQuery=${searchQuery}`);
        const param = {
            search: searchQuery,
        };
        dispatch(getNuggetsAction(param));
    }

    const handleResetFilters = () => {
        setSearchQuery('');
        navigate(`/nuggets`);
        dispatch(getNuggetsAction());
    };

    if (!nuggets)
        return <>Loading...</>;

    return (
        <Container className='py-4'>
            <Card className="mb-4 shadow-sm border-0">
                <Card.Body>
                    <Row className="gy-3 gx-3 align-items-end">
                        <Col md={4} xs={12}>
                            <Form.Label htmlFor="searchInput" className="fw-semibold">Search</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    id="searchInput"
                                    placeholder="Search techniques..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyPress={handleSearch}
                                />
                            </InputGroup>
                            <Button
                                className='mt-2'
                                onClick={handleSearchButtonClick}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col md={1} xs={12} className="d-flex gap-2 justify-content-end align-items-center mt-md-0 mt-3">
                            <Button variant="secondary" onClick={handleResetFilters}>
                                Reset
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <div className="d-none d-md-block"> {/* Hide table on mobile */}
                <Table hover responsive className="talk-table">
                    <colgroup>
                        <col style={{ width: '70%' }} />
                        <col style={{ width: '30%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        {nuggets?.map((nugget) => (
                            <tr
                                key={nugget._id}
                                className="talk-row"
                                onClick={() => navigate(`/nuggets/${nugget?._id}`)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td>
                                    <div className="title-cell">
                                        <strong title={nugget?.title}>{nugget?.title}</strong>
                                    </div>
                                </td>
                                <td>{nugget?.durationHhmmss}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Mobile Card View */}
            <div className="d-md-none"> {/* Show only on mobile */}
                <div className="talk-cards">
                    {nuggets?.map((nugget) => (
                        <div
                            key={nugget._id}
                            className="talk-card-mobile"
                            onClick={() => navigate(`/nuggets/${nugget._id}`)}
                        >
                            <h5 className="talk-card-title" title={nugget?.title}>
                                {nugget?.title}
                            </h5>
                            <div className="talk-card-meta">
                                <span className="meta-item">
                                    <small className="text-muted">Duration:</small> {nugget?.durationHhmmss}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    )
}

export default NuggetPage